import { AiPrompt } from '@provision/entity-types';
import { gql, useQuery } from '@provision/graphql-client';
import { useMemo } from 'react';
import { PLATFORM_PARTNER_ID } from 'src/constants/platform';
import { Records } from 'src/graphql/types';
import { useGlobalStore } from 'src/store';
import { useCurrentUserProfile } from './platform-user';

const GET_ENABLED_AI_PROMPT_QUERY = gql`
  query GetEnabledAiPrompts($params: GetEnabledAiPromptsInput!) @entity(name: "AiPrompt") {
    getEnabledAiPrompts(params: $params) {
      records {
        id
        promptId
        partnerId
        createdBy
        friendlyName
        content
        active
      }
    }
  }
`;

interface GetAiPromptQuery {
  getEnabledAiPrompts: Records<AiPrompt>;
}

export const useAiPrompts = (options?: { skip?: boolean }) => {
  const { user } = useCurrentUserProfile();
  const selectedPartnerId = useGlobalStore.use.selectedPartnerId();
  const { data, ...rest } = useQuery<GetAiPromptQuery>(GET_ENABLED_AI_PROMPT_QUERY, {
    skip: options?.skip,
    variables: {
      params: {
        userId: user?.userId,
        // We can default to platform-level ID because platform-level prompts are always available
        partnerId: selectedPartnerId || PLATFORM_PARTNER_ID,
      },
    },
  });

  const aiPrompts = useMemo(
    () => data?.getEnabledAiPrompts.records || [],
    [data?.getEnabledAiPrompts.records],
  );

  return { aiPrompts, ...rest };
};
